import React, { Component } from 'react';
import './styles.scss';

import { History } from 'history';

type Props = {
  history: History;
};

export default class NewAppointmentButton extends Component<Props> {
  bookNewAppointment() {
    this.props.history.replace('/booking-quiz');
  }

  render() {
    return (
      <div className="new-appointment-button" onClick={this.bookNewAppointment.bind(this)}>
        <h3 className="h3">Book +</h3>
      </div>
    );
  }
}
